// import scss
import "./scss/main.scss";

// import $ from "jquery";
import $ from "cash-dom"; // jQuery alternative
import axios from 'axios'; // ajax http request lib
import dayjs from 'dayjs'; // date manipulation lib
import 'dayjs/locale/nl'; // locales for dayjs
import {
    Event,
    Element,
    Collapse,
    Tooltip,
    Modal
} from 'bootstrap'; // bootstrap utils
import Litepicker from 'litepicker'; // date picker
import Swiper, {
    Navigation,
    Pagination
} from 'swiper'; // touch friendly image galery
import {
    SearchBox
} from './js/filterbox.js'; // dynamically build filters

// give swiper some extra abilities
Swiper.use([Navigation, Pagination]);

// set nl locale on dayjs
dayjs.locale('nl');



// execute on dom:loaded
$(function() {
    console.log('hello at document ready from index.js');

    init_clickables();

    if ($('.home-filter-box').length >= 1) {
        var $container = $('.home-filter-box');

        var box = new SearchBox($container[0], {
            'endpoint': '/api/search/vakantiehuizen',
            'load': '/zoek-een-vakantiehuis',
            'reset': false,
            'filters': [{
                'search': 'countries',
                'source': 'countries',
                'display_type': 'locations'
            }, {
                'search': 'regions',
                'source': 'regions',
                'display_type': 'locations'
            }, {
                'search': 'checkins',
                'source': 'checkins',
                'display_type': 'date'
            }, {
                'search': 'checkouts',
                'source': 'checkouts',
                'display_type': 'date'
            }, {
                'search': 'occupations',
                'source': 'occupations',
                'display_type': 'partyselect'
            }]
        });
    }

    if ($('.lister-filter-box').length >= 1) {
        var $container = $('.lister-filter-box');

        var box = new SearchBox($container[0], {
            'endpoint': '/api/search/vakantiehuizen',
            'load': '/zoek-een-vakantiehuis',
            'reset': false,
            'cta': false,
            'filters': [{
                'search': 'countries',
                'source': 'countries',
                'display_type': 'locations'
            }, {
                'search': 'regions',
                'source': 'regions',
                'display_type': 'locations'
            }, {
                'search': 'checkins',
                'source': 'checkins',
                'display_type': 'date'
            }, {
                'search': 'checkouts',
                'source': 'checkouts',
                'display_type': 'date'
            }, {
                'search': 'occupations',
                'source': 'occupations',
                'display_type': 'partyselect'
            }, {
                'search': 'pets',
                'source': 'pets',
                'display_type': 'partyselect'
            }],
            'updateFilters': (e) => {
                console.info('disabled dynamic filter update')
            },
            'onAfterApply': (e) => {
                $('#lister-search-form').get(0).submit();
            },
            'onAfterCancel': (e) => {
                $('#lister-search-form').get(0).submit();
            },
        });
    }

    if ($('#lister-search-form').length >= 1) {
        $('#lister-search-form input.facet-search, #lister-search-form select.facet-search, select.lister-sorting').on('change', (e) => {
            $('#lister-search-form')[0].submit();
        });

        // $('#facet-search input[type="range"]').on('change', (e) => {
        //   window.setTimeout(() => { $('#facet-search').trigger('submit'); }, 2000);
        // });
    }



    var default_swiper_config = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
        }
    }

    // themes swiper on homepage
    if ($('.swiper-themes').length >= 1) {
        var themes_swiper_config = Object.assign({}, default_swiper_config);
        themes_swiper_config.navigation = {
            nextEl: '.swiper-button-next.swiper-button-themes',
            prevEl: '.swiper-button-prev.swiper-button-themes',
        };
        new Swiper('.swiper-themes', themes_swiper_config);
    }

    // destinations swiper on homepage
    if ($('.swiper-destinations').length >= 1) {
        var destinations_swiper_config = Object.assign({}, default_swiper_config);
        destinations_swiper_config.navigation = {
            nextEl: '.swiper-button-next.swiper-button-destinations',
            prevEl: '.swiper-button-prev.swiper-button-destinations',
        };
        new Swiper('.swiper-destinations', destinations_swiper_config);
    }

    // accos swiper on homepage
    if ($('.swiper-accos').length >= 1) {
        var accos_swiper_config = Object.assign({}, default_swiper_config);
        accos_swiper_config.navigation = {
            nextEl: '.swiper-button-next.swiper-button-accos',
            prevEl: '.swiper-button-prev.swiper-button-accos',
        };
        new Swiper('.swiper-accos', accos_swiper_config);
    }

    // image galery swiper on destination and theme pages
    if ($('.swiper-img-gallery').length >= 1) {
        new Swiper('.swiper-img-gallery', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next.swiper-button-gallery',
                prevEl: '.swiper-button-prev.swiper-button-gallery',
            },
        });
    }

    // acco image swipers on lister page
    if ($(".accoswiper").length >= 1) {

        $(".accoswiper").each(function(index) {
            new Swiper(".accoswiper", {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        });
    }

    // hero swiper on acco detail page
    if ($(".acco-detail-swiper").length >= 1) {
        console.warn('initializing .acco-detail-swiper');

        var swiper = new Swiper(".acco-detail-swiper", {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1,
            loop: true,
            loopFillGroupWithBlank: true,
            // autoplay: {
            //   delay: 2500,
            //   disableOnInteraction: false,
            // },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                }
            },
        });
    }

    // ## ######## ##
    // ## Tooltips ##
    // ## ######## ##
    $('[data-bs-toggle="tooltip"]').each((idx, tooltipTriggerEl) => {
        console.info('initialize tooltip');
        return new Tooltip(tooltipTriggerEl);
    });


    // ## ################ ##
    // ## Read more / less ##
    // ## ################ ##
    if ($(".readmore_field").length >= 1) {
        $(".readmore_field").each(function(index, element) {
            // clone content to a cloned modal for mobile
            var $element = $(element);
            var content = $element.html();
            var template = $("#modalTemplate").clone();
            template.find(".modal-title").html($element.data("title"));
            template.find(".modal-body").html(content);
            template.find('.modal-footer').hide();
            template.attr("id", "mobile_modal_" + $element.data("title"))
            $("main").append(template);
        });
    }

    if ($(".js_read_more").length >= 1) {
        $(".js_read_more").on("click", function(ev) {
            var $target = $(ev.target);

            if ($(window).width() > 768 || $target.hasClass("all_normal")) {
                if ($("#" + $target.attr('aria-controls')).hasClass("show")) {
                    $("#" + $target.attr('aria-controls')).removeClass("show")
                    $target.html($target.data("more_text"))
                } else {
                    $("#" + $target.attr('aria-controls')).addClass("show")
                    $target.html($target.data("less_text"))
                }
            } else {
                console.info('create and show modal for ' + $target.data("target_title"));
                var myModal = new Modal(document.getElementById('mobile_modal_' + $target.data("target_title")), {
                    keyboard: false
                })
                myModal.show()
            }
        })
    }



    function zeroPad(num, places) {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join("0") + num;
    }


    // date picker
    if ($("#datepickr").length >= 1) {

        const format = 'YYYY-MM-DD';
        const display_format = 'D MMM YYYY';

        let today = dayjs(); //Gets today's date in a moment object
        today.subtract(1, 'days').format(format); //Subtract a day, then format to whatever your 'lockDaysFormat' string is.

        let datepicker_config = {
            element: $('#datepickr')[0],
            singleMode: false,
            numberOfMonths: 2,
            switchingMonths: 1,
            // numberOfColumns: 2,
            mobileFriendly: true,
            lockDaysFormat: format,
            autoApply: false,
            buttonText: {
                "apply": "Toepassen",
                "cancel": "Datum wissen"
            },
            showTooltip: false,
            showWeekNumbers: false,
            minDate: today,
        };

        if (typeof available_dates != 'undefined') {
            console.info('we have a list of available dates');
            datepicker_config.lockDaysFilter = (date1, date2, picked_dates) => {
                var date1_date = dayjs(date1.dateInstance).format(format);

                if (picked_dates.length == 2 &&
                    (picked_dates[0].format(format) == date1.format(format) ||
                        picked_dates[1].format(format) == date1.format(format))) {
                    return false;
                }

                if (picked_dates.length == 1) {
                    var selected_date = dayjs(picked_dates[0].dateInstance).format(format);
                    if (Object.keys(mapped_checkin_checkouts).includes(selected_date)) {
                        return !mapped_checkin_checkouts[selected_date].includes(date1_date);
                    }
                }
                return !available_dates.includes(date1_date);
            }

            // get the last date by the last checkout of the last available date
            const last_available_date = available_dates[available_dates.length - 1];
            const last_checkouts = mapped_checkin_checkouts[last_available_date];

            if (last_checkouts) {
                const last_available_checkout_date = last_checkouts[last_checkouts.length - 1];
                datepicker_config.maxDate = last_available_checkout_date;
            }

            datepicker_config.tooltipText = {
                one: 'nacht',
                other: 'nachten'
            };

            datepicker_config.showTooltip = true;
            datepicker_config.tooltipNumber = (totalDays) => {
                return totalDays - 1;
            };
        } else {
            datepicker_config.lockDays = [
                ['2021-01-01', today]
            ];
        }

        if (typeof available_durations != 'undefined') {
            console.info('we have a list of available durations');
            datepicker_config.minDays = available_durations[0];
            datepicker_config.maxDays = available_durations[available_durations.length - 1];
        }

        // initialize the datepicker
        const picker = new Litepicker(datepicker_config);

        if ($(".date_container").length >= 1) {
            $(".date_container").on('click', (ev) => {
                picker.show();
                $("#checkin_container").addClass("active");
            })


            // this is to highlight the date to be selected
            picker.on('before:click', (target) => {
                if ($(target).attr('type') != "button") {

                    var d = dayjs($(target).data("time"));

                    if (!$(target).hasClass("is-end-date")) {
                        $("#checkin_container").removeClass("active");
                        $("#checkin_container .value").html(d.format(display_format))
                        $("#checkout_container").addClass("active");
                    } else {
                        $("#checkout_container .value").html(d.format(display_format))
                    }
                }
            });

            // remove active class when dates are selected
            picker.on('selected', (date1, date2) => {
                $(".date_container").removeClass("active")
            });

            // when picker is being hided/closed
            picker.on('hide', () => {
                $(".date_container").removeClass("active")
            });


            // on a lister we select a range of checkin dates, not checkin and checkout
            if ($("#checkin_start").length > 0 && $("#checkin_end").length > 0) {
                console.debug('we\'re on a listerpage');

                // mark the current selection
                picker.setDateRange($("#checkin_start").val(), $("#checkin_end").val());

                picker.on('button:apply', (date1, date2) => {
                    let checkin_start = dayjs(date1.dateInstance),
                        checkin_end = dayjs(date2.dateInstance);

                    console.info(checkin_start.toISOString());
                    $("#checkin_start").val(checkin_start.toISOString()); // solr needs iso strings
                    $("#checkin_end").val(checkin_end.toISOString()); // solr needs iso strings

                    $("#checkinstart_display").html(checkin_start.format(display_format));
                    $("#checkinend_display").html(checkin_end.format(display_format));

                    $('#lister-search-form')[0].submit();
                });

                picker.on('button:cancel', () => {
                    picker.clearSelection();
                    picker.show();
                    let checkin_start = dayjs($("#checkin_start").val()),
                        checkin_end = dayjs($("#checkin_end").val());

                    $("#checkinstart_display").html(checkin_start.format(display_format));
                    $("#checkinend_display").html(checkin_end.format(display_format));
                });

            }

            // on a detail page we do have a checkin and a checkout
            if ($("#checkin").length > 0 && $("#checkout").length > 0) {
                console.debug('we\'re on a detailpage');

                // mark the current selection
                picker.setDateRange($('#checkin').val(), $('#checkout').val());

                let checkin = dayjs($("#checkin").val()),
                    checkout = dayjs($("#checkout").val());

                $("#checkin_container .value").html(checkin.format(display_format));
                $("#checkout_container .value").html(checkout.format(display_format))

                picker.on('button:apply', (date1, date2) => {
                    let checkin = dayjs(date1.dateInstance),
                        checkout = dayjs(date2.dateInstance);

                    $("#checkin").val(checkin.format(format)); // solr needs iso strings
                    $("#checkout").val(checkout.format(format)); // solr needs iso strings

                    $("#checkin_container .value").html(checkin.format(display_format));
                    $("#checkout_container .value").html(checkout.format(display_format));

                    request_price_calculation();
                });

                picker.on('button:cancel', () => {
                    picker.clearSelection();
                    picker.show();
                    let checkin = dayjs($("#checkin").val()),
                        checkout = dayjs($("#checkout").val());

                    $("#checkin_container .value").html(checkin.format(display_format));
                    $("#checkout_container .value").html(checkout.format(display_format))
                });

                // since we know that we're on a detailpage, lets ask for a price calculation
                request_price_calculation();
            }

        }
    }

    if ($('#btn_scroll_to_book').length > 0) {
        $('#btn_scroll_to_book').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            console.info($('#price_offer_form'));
            $('#price_offer_form')[0].scrollIntoView({
                behavior: "smooth"
            });
        });
    }

    ///////////////////////////
    ///////////////////////////
    // BOOKING INFO SELECTOR //
    ///////////////////////////
    ///////////////////////////
    $("body").on("click", function(e) {
        if ($(".booking_spec_input_box").hasClass("active")) {
            if (
                $(e.target).closest("#booking_spec_container").length == 0 &&
                $(e.target).closest("#booking_spec_input_box").length == 0
            ) {
                $(".booking_spec_input_box").removeClass("active")
            }
        }

        if ($(".booking_location_input_box").hasClass("active")) {
            if (
                $(e.target).closest("#booking_location_container").length == 0 &&
                $(e.target).closest("#booking_location_prefs").length == 0
            ) {
                $(".booking_location_input_box").removeClass("active")
            }
        }
    })

    $(".js_open_container").on("click", function(e) {
        if ($(e.target).hasClass("js_open_container") || $(e.target).parent().hasClass("js_open_container")) {
            $("#" + $(this).data('target')).addClass("active")
            $("#" + $(this).data('target')).css("width", $(".booking_prefs_info").css("width"))
        }
    })

    $(".form-check-input").on("click", function() {
        if ($(this).is(':checked')) {
            $(this).prop("checked", true)
            $(this).attr("checked", true);
        } else {
            $(this).prop("checked", false)
            $(this).attr("checked", false);
        }
    })

    $(".js_clear_location").on("click", function() {
        $(".js_booking_location_region").prop("checked", false).removeAttr("checked");
        $(".js_booking_location_country").prop("checked", false).removeAttr("checked");
    })

    $(".js_apply_location").on("click", function(e) {
        var $elem = $(e.target).closest("#booking_location_prefs");
        $("#countryvalue").html("")
        $("#regionvalue").html("")
        $(".js_booking_location_country:checked").each(function(index) {
            $("#countryvalue").append($(this).val() + ", ")
        })

        var str = $("#countryvalue").html();
        $("#countryvalue").html(str.substring(0, str.length - 2));
        $(".js_booking_location_region:checked").each(function(index) {
            $("#regionvalue").append($(this).val() + ", ")
        })

        var str = $("#regionvalue").html();
        $("#regionvalue").html(str.substring(0, str.length - 2));
        $elem.removeClass("active")
    })

    $(".js_cancel_prefs").on("click", function(e) {
        var $elem = $(e.target).closest("#booking_spec_input_box");

        if ($("#numAdults").val() > 0) {
            $elem.find("#NumtempAdult").val($("#numAdults").val())
        } else {
            $elem.find("#NumtempAdult").val(0)
        }

        if ($("#numChildren").val() > 0) {
            $elem.find("#NumtempChild").val($("#numChildren").val())
        } else {
            $elem.find("#NumtempChild").val(0)
        }

        if ($("#numBabies").val()) {
            $elem.find("#NumtempBaby").val($("#numBabies").val())
        } else {
            $elem.find("#NumtempBaby").val(0)
        }

        if ($("#numDogs").val()) {
            $elem.find("#NumtempDog").val($("#numDogs").val())
        } else {
            $elem.find("#NumtempDog").val(0)
        }

        $elem.removeClass("active")
    })



    $(".js_apply_prefs").on("click", function(e) {
        if ($(this).hasClass("apply_pers_dog_only")) {
            var $elem = $(e.target).closest("#booking_spec_input_box");
            $("#numAdults").val($elem.find("#NumtempAdult").val())
            $("#numChildren").val($elem.find("#NumtempChild").val())
            $("#numBabies").val($elem.find("#NumtempBaby").val())
            $("#numDogs").val($elem.find("#NumtempDog").val())
            $("#personvalue").html(parseInt($elem.find("#NumtempAdult").val()) + parseInt($elem.find("#NumtempChild").val()) + parseInt($elem.find("#NumtempBaby").val()))
            $("#dogvalue").html($elem.find("#NumtempDog").val())
            $elem.removeClass("active")
        } else {
            var $elem = $(e.target).closest("#booking_spec_input_box");
            $("#numAdults").val($elem.find("#NumtempAdult").val())
            $("#numChildren").val($elem.find("#NumtempChild").val())
            $("#numBabies").val($elem.find("#NumtempBaby").val())
            $("#numDogs").val($elem.find("#NumtempDog").val())
            $("#adultvalue").html($elem.find("#NumtempAdult").val())
            $("#childvalue").html(parseInt($elem.find("#NumtempChild").val()) + parseInt($elem.find("#NumtempBaby").val()))
            $("#dogvalue").html($elem.find("#NumtempDog").val())
            $elem.removeClass("active")
        }

        request_price_calculation();
    })

    if ($(".js_open_mobile_filters").length >= 1) {
        $(".js_open_mobile_filters").on("click", function() {
            $("#filter_panel").addClass("active")
            $("body").addClass("modal-open");
            $("body").css({
                "overflow": "hidden",
                "padding-right": "16px"
            })
        })
    }

    if ($(".js_apply_filters").length >= 1) {
        $(".js_apply_filters").on("click", function() {

            $("#filter_panel").removeClass("active")
            $("body").removeClass("modal-open");
            $("body").css({
                "overflow": "unset",
                "padding-right": "unset"
            })
        })
    }

    $(".js_move_datepicker").on("click", function() {
        if ($(this).hasClass("js_datepicker_align_right")) {
            $(".litepicker").css("left", $(this).position().left + $(this).outerWidth() - $(".litepicker").outerWidth())
        } else {
            $(".litepicker").css("left", $(this).position().left)
        }
    })

    $(".js_input_field_alter").on("click", function() {
        var curValue = parseInt($(this).parent().find("input").val(), 10);

        if ($(this).hasClass("js_input_min")) {
            if (curValue > parseInt($(this).parent().find("input").attr("min"), 10)) {
                $(this).parent().find("input").val(curValue - 1)
            }
        } else if ($(this).hasClass("js_input_plus")) {
            if (curValue < parseInt($(this).parent().find("input").attr("max"), 10)) {
                $(this).parent().find("input").val(curValue + 1)
            }
        }
    });

    if ($(".js_birthdate_field").length >= 1) {
        var Days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // index => month [0-11]
        var option = '<option value="day">day</option>';
        var selectedDay = "day";
        for (var i = 1; i <= Days[0]; i++) { //add option days
            option += '<option value="' + i + '">' + i + '</option>';
        }
        $('#day').append(option);
        $('#day').val(selectedDay);

        var option = '<option value="month">month</option>';
        var selectedMon = "month";
        for (var i = 1; i <= 12; i++) {
            option += '<option value="' + i + '">' + i + '</option>';
        }
        $('#month').append(option);
        $('#month').val(selectedMon);

        var d = new Date();
        var option = '<option value="year">year</option>';
        var selectedYear = "year";
        for (var i = 1930; i <= d.getFullYear(); i++) { // years start i
            option += '<option value="' + i + '">' + i + '</option>';
        }
        $('#year').append(option);
        $('#year').val(selectedYear);

        function isLeapYear(year) {
            year = parseInt(year);
            if (year % 4 != 0) {
                return false;
            } else if (year % 400 == 0) {
                return true;
            } else if (year % 100 == 0) {
                return false;
            } else {
                return true;
            }
        }

        $(".js_birthdate_field").on("change", function() {
            if ($(this).data("type") == "month") {
                var day = $('#day');
                var val = $(day).val();
                $(day).empty();
                var option = '<option value="day">day</option>';
                var month = parseInt($($(this)).val()) - 1;
                for (var i = 1; i <= Days[month]; i++) { //add option days
                    option += '<option value="' + i + '">' + i + '</option>';
                }
                $(day).append(option);
                if (val > Days[month]) {
                    val = 1;
                }
                $(day).val(val);
            } else if ($(this).data("type") == "year") {
                if (isLeapYear($($(this)).val())) {
                    Days[1] = 29;
                } else {
                    Days[1] = 28;
                }
                if ($("#month").val() == 2) {
                    var day = $('#day');
                    var val = $(day).val();
                    $(day).empty();
                    var option = '<option value="day">day</option>';
                    for (var i = 1; i <= Days[1]; i++) { //add option days
                        option += '<option value="' + i + '">' + i + '</option>';
                    }
                    $(day).append(option);
                    if (val > Days[month]) {
                        val = 1;
                    }
                    $(day).val(val);
                }
            }
        });
    }

    let receipt_loading = false,
        wants_calculation = false;

    function request_price_calculation() {
        console.info('requesting price calculation');
        console.debug($('#price_offer_form').serialize());

        if (receipt_loading) {
            console.info('calculation already running');
            wants_calculation = true;
            return;
        }


        let data = '';
        if ($('#price_offer_form').length > 0) {
            data = $('#price_offer_form').serialize();
        }

        $('#receipt').html('<p class="loading">Bezig met berekenen, een ogenblik geduld aub.</p>');

        let book_link = $('#receipt_booklink');
        if (book_link.length > 0) {
            $('#receipt_booklink').hide();
        }


        axios({
            method: 'post',
            url: '/api/bookrequest/calculate',
            data: data
        }).then((xmlHttpResponse) => {
            console.info(xmlHttpResponse.data);

            const formatter = new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR'
            });
            const data = xmlHttpResponse.data;

            var receipt_html = '<ul>';

            ['reissom', 'toeslagen'].forEach(function(group) {
                data[group].forEach(function(el) {

                    let price = 'incl.';

                    if (parseFloat(el.price) > 0) {
                        price = formatter.format(el.price);
                    }

                    receipt_html += '<li><span data-code="' + el.id + '">' + el.description + '</span><span class="text-end">' + price + '</span></li>';
                });
            });

            // check for book costs and np taxes
            if (np_required_taxes.length >= 1) {
                np_required_taxes.forEach(function(el) {
                    let price = 'incl.';

                    if (parseFloat(el.price) > 0) {
                        price = formatter.format(el.price);
                    }

                    receipt_html += '<li data-code="' + el.code + '"><span>' + el.description + '</span><span class="text-end">' + price + '</span></li>';
                });
            }

            if (np_book_cost > 0) {
                price = formatter.format(np_book_cost);
                receipt_html += '<li><span>Boekingskosten</span><span class="text-end">' + price + '</span></li>';
            }

            receipt_html += '<li><span>Totaal</span><span class="text-end">' + formatter.format(data.total_price) + '</span></li>';

            $('#receipt').html(receipt_html);

            var show_mandatory_costs = false;
            var local_mandatory_costs = '';
            ['lokale_toeslagen'].forEach(function(group) {
                data[group].forEach(function(el) {

                    let price = 'incl.';

                    if (parseFloat(el.price) > 0) {
                        price = formatter.format(el.price);
                    }

                    local_mandatory_costs += el.description + ' <span class="fs-small">(' + price + ' ' + el.mode_description + ')</span><br>';

                    show_mandatory_costs = true;
                });
            });

            $('#mandatory_local_costs div.body').html(local_mandatory_costs);

            if (show_mandatory_costs) {
                $('#mandatory_local_costs').show();
            }

            let book_link = $('#receipt_booklink');

            if (book_link.length > 0) {
                let book_link_href = book_link[0];
                let search = new URLSearchParams(book_link_href.search);

                // update search on booklink
                ['checkin_date', 'checkout_date', 'trip_id'].forEach((key) => {
                    search.set(key, xmlHttpResponse.data[key]);
                });

                search.set('occupancy', $('#numAdults').val());
                search.set('babies', $('#numBabies').val());
                search.set('pets', $('#numDogs').val());

                book_link_href.search = search;

                $('#receipt_booklink').show().css('display', 'inline-block');
            }




            // $('#receipt_checkin').html(dayjs(xmlHttpResponse.data.departure, 'YYYY-MM-DD').format('D MMMM YYYY'));
            // $('#receipt_checkout').html(dayjs(xmlHttpResponse.data.return, 'YYYY-MM-DD').format('D MMMM YYYY'));
            // $('#receipt_duration').html(xmlHttpResponse.data.stay_nights);
            // $('#receipt_occupancy').html(xmlHttpResponse.data.total_pax);
            // $('#receipt_route').html(xmlHttpResponse.data.route);
            // $('#receipt_total').html(formatter.format(xmlHttpResponse.data.total_price));


            // if ($('#receipt_total--mobile')) {
            //   $('#receipt_total--mobile').html(formatter.format(xmlHttpResponse.data.total_price));
            // }


            // let components = '';

            // ['reissom', 'divecentre', 'extras', 'x'].forEach((group, idx) => {
            //   if (Object.keys(xmlHttpResponse.data).indexOf(group) >= 0) {
            //     xmlHttpResponse.data[group].forEach((el, idx) => {
            //       components += '<li class="'+ el.group +'">'+ el.description +' <span class="font-medium">'+ (el.price > 0 ? formatter.format(el.price) : '') +'</span></li>';
            //     });
            //   }
            // });

            // // console.info(components);

            // $('#receipt_components').html(components);

            // $('.m-receipt__meta, .m-receipt__footer, .m-receipt__body').show();

            // let book_link = $('#receipt_booklink');

            // if (book_link.length > 0) {
            //   let book_link_href = book_link[0];
            //   let search = new URLSearchParams(book_link_href.search);

            //   // update search on booklink
            //   ['package_id', 'checkin', 'trip_id', 'occupancy'].forEach((key) => {
            //     search.set(key, xmlHttpResponse.data[key]);
            //   });
            //   book_link_href.search = search;
            // }

            receipt_loading = false;
            if (wants_recalculation) {
                wants_recalculation = false;
                // request_price_calculation();
            }
        }).catch(function(error) {
            // console.log(error);
            receipt_loading = false;
            // $('.m-receipt__msg--loading').hide();
        });
    }
});

function init_clickables() {
    var aclickables = $('div.clickable');
    aclickables.each(function(idx, el) {
        $(el).on('click', (e) => {

            // first check if we are not using the slides..
            const $target = $(e.target);
            // if ($target.parents('div.swiper-slide').length >= 1) {
            //   return;
            // }

            if ($target.hasClass('swiper-button-next') || $target.hasClass('swiper-button-prev')) {
              return;
            }

            var $container = $(this).closest('div.clickable');

            if ($container.length <= 0) {
                return;
            };

            if ($container.get(0).tagName.search(/^a|input$/i) != -1) {
                return;
            };

            if ($container.hasClass('exception')) {
                return;
            };

            var $link = $container.find('a.clickable');
            if ($link.length <= 0) {
              return;
            }

            var href = $link.attr('href');
            if ($link.hasClass('newwindow')) {
                window.open(href);
            } else {
                document.location = href;
            }
        });
    });
}
